import { MediaPlanTableData } from '@/features/media-plans/media-plans-table';
import { ExecutionLineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';

export function generateMediaPlansTotalRow(
  lineItem: ExecutionLineItemTrpcResponse,
  rows: MediaPlanTableData[]
): MediaPlanTableData {
  const actual_delivered_units = rows
    .map(r => r.metrics?.actual_delivered_units || 0)
    .reduce(sum, 0);
  const actual_spend = rows.map(r => r.metrics?.actual_media_spend || 0).reduce(sum, 0);
  const current_margin = lineItem.effective_unit_price
    ? (actual_delivered_units * lineItem.effective_unit_price - actual_spend) /
      (actual_delivered_units * lineItem.effective_unit_price)
    : 0;
  const unit_cost_incurred = actual_delivered_units > 0 ? actual_spend / actual_delivered_units : 0;

  return {
    isTotal: true,
    id: '__TOTAL_ROW__',
    name: '',
    media_buy: null,
    is_deleted: false,
    metrics: {
      target_margin: rows[0]?.metrics?.target_margin || 0,
      actual_delivered_units,
      actual_media_spend: actual_spend,
      unit_cost_incurred,
      current_margin
    }
  };
}

function sum(a: number, b: number) {
  return a + b;
}
